import { ILeadOppProduct } from '@user/store/leadOppProducts'
import { useMemo } from 'react'
import { tax } from '@user/components/Services/AddServiceForm/typings'

type Props = {
  service: ILeadOppProduct
}

export function useData(props: Props) {
  const {
    service: {
      annualOccurrences,
      initialDiscountAmount,
      initialDiscountType,
      initialPrice,
      quantity,
      recurringDiscountAmount,
      recurringDiscountType,
      recurringPrice,
      taxRate,
      gstHstRate,
      pstQstRate,
    },
  } = props

  const initialDiscount =
    initialDiscountType === 'dollar'
      ? initialDiscountAmount
      : initialDiscountAmount * initialPrice

  const recurringDiscount =
    recurringDiscountType === 'dollar'
      ? recurringDiscountAmount
      : recurringDiscountAmount * recurringPrice

  const total = useMemo(
    () =>
      quantity *
      (initialPrice -
        initialDiscount +
        annualOccurrences * (recurringPrice - recurringDiscount)),
    [
      annualOccurrences,
      initialDiscount,
      initialPrice,
      quantity,
      recurringDiscount,
      recurringPrice,
    ],
  )

  const taxTotal = useMemo(() => tax(total, taxRate), [total, taxRate])

  // Canadian Tax calculation for GST & PST
  const gstTaxTotal = useMemo(() => tax(total, gstHstRate), [total, gstHstRate])

  const pstTaxTotal = useMemo(() => tax(total, pstQstRate), [total, pstQstRate])

  return {
    taxTotal,
    initialDiscount,
    recurringDiscount,
    gstTaxTotal,
    pstTaxTotal,
  } as const
}
